import * as yup from 'yup';
import { regexLinkedinURLValidator, validatePhoneNumber } from './common';

export enum ValidationType {
    STRING = 'string',
    DATE_TIME = 'date-time',
    DATE = 'date',
    SINGLE_SELECT_STRING_ARRAY = 'single-select-string-array',
    MOBILE = 'mobile',
    PHONE = 'phone',
    NUMBER = 'number',
    INTEGER = 'integer',
    INTEGER_POSITIVE = 'integer-positive',
    BOOLEAN = 'boolean',
    BOOLEAN_VALUE = 'boolean-value',
    ARRAY = 'array',
    OBJECT = 'object',
    URL = 'url',
    URI = 'uri',
    EMAIL = 'email',
    PASSWORD = 'password',
    RETYPED_PASSWORD = 'retyped-password',
    CONFIRM_PASSWORD = 'confirmPassword',
    SINGLE_SELECT = 'single-select',
    SINGLE_SELECT_OBJECT_ARRAY = 'single-select-object-array',
    MULTI_SELECT = 'multi-select',
    MULTI_SELECT_ARRAY = 'multi-select-array',
    TABLE = 'table',
    LINKEDIN_URL = 'linkedin-url',
}

/**
 * validateField
 * @param {string} type
 * @param {boolean} isRequired default value is true
 * @param {string} errorMessage custom error message
 * @returns yup schema object
 */
export const validateField = (
    type: string,
    isRequired = true,
    errorMessage: string | undefined = undefined
): yup.Schema => {
    let schema;
    switch (type) {
        case ValidationType.STRING:
        case ValidationType.DATE_TIME:
        case ValidationType.DATE:
        case ValidationType.SINGLE_SELECT_STRING_ARRAY:
            schema = yup.string().nullable();
            break;
        case ValidationType.MOBILE:
        case ValidationType.PHONE:
            schema = yup.string().test('validateMobile', 'Invalid Phone Number', function (value) {
                return value ? validatePhoneNumber(value) : true;
            });
            break;
        case ValidationType.NUMBER:
            schema = yup.number().nullable();
            break;
        case ValidationType.INTEGER:
            schema = yup.number().integer().nullable();
            break;
        case ValidationType.INTEGER_POSITIVE:
            schema = yup
                .number()
                .integer()
                .positive(errorMessage || 'This field must be a positive number')
                .nullable();
            break;
        case ValidationType.BOOLEAN:
            schema = yup.string().nullable();
            // schema = yup.boolean().nullable();
            break;
        case ValidationType.BOOLEAN_VALUE:
            schema = yup.boolean().nullable();
            break;
        case ValidationType.ARRAY:
            schema = yup.array().nullable();
            break;
        case ValidationType.OBJECT:
            schema = yup.object().nullable();
            break;
        case ValidationType.URL:
        case ValidationType.URI:
            schema = yup.string().url(errorMessage).nullable();
            break;
        case ValidationType.EMAIL:
            schema = yup.string().email('Invalid email address').nullable();
            break;
        case ValidationType.PASSWORD:
            schema = yup
                .string()
                // .matches(
                //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*-+])(?=.{6,})/,
                //   'Must Contain 6 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
                // )
                .nullable();
            break;
        case ValidationType.RETYPED_PASSWORD:
            schema = yup
                .string()
                .oneOf([yup.ref('newPassword')], errorMessage || 'Passwords must match');
            break;
        case ValidationType.CONFIRM_PASSWORD:
            schema = yup
                .string()
                .oneOf([yup.ref('password')], errorMessage || 'Passwords must match');
            break;
        case ValidationType.SINGLE_SELECT:
        case ValidationType.SINGLE_SELECT_OBJECT_ARRAY:
            schema = yup.object().nullable();
            break;
        case ValidationType.MULTI_SELECT:
        case ValidationType.MULTI_SELECT_ARRAY:
            schema = yup.array().min(1, errorMessage || `Select at least one option`);
            break;
        case ValidationType.TABLE:
            schema = yup.array().min(1, 'This is a required field');
            break;
        case ValidationType.LINKEDIN_URL:
            schema = yup.string().test('validateLinkedinURL', 'Invalid URL', function (value) {
                return value ? regexLinkedinURLValidator(value) : true;
            });
            break;

        default:
            throw new Error(`Invalid type: ${type}`);
    }

    if (isRequired && schema) {
        schema = schema.required(errorMessage || 'This is a required field');
    }

    return schema;
};
